export default function CorrectIocn() {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="75"
        height="75"
        rx="37.5"
        fill="#11A75C"
        fill-opacity="0.25"
      />
      <rect
        x="6"
        y="5.83301"
        width="63.3346"
        height="63.3347"
        rx="31.6673"
        fill="#1DB469"
      />
      <path
        d="M34.7486 49.9175C34.0361 49.9187 33.3426 49.6883 32.7727 49.2609L32.7373 49.2344L25.2951 43.5413C24.9504 43.277 24.6611 42.9475 24.4438 42.5714C24.2265 42.1954 24.0854 41.7802 24.0285 41.3497C23.9716 40.9191 24.0001 40.4815 24.1123 40.0619C24.2246 39.6424 24.4183 39.249 24.6826 38.9043C24.9468 38.5597 25.2764 38.2704 25.6524 38.0531C26.0284 37.8358 26.4436 37.6946 26.8742 37.6378C27.3048 37.5809 27.7423 37.6094 28.1619 37.7216C28.5815 37.8338 28.9748 38.0276 29.3195 38.2919L34.14 41.9884L45.531 27.1275C45.7952 26.783 46.1246 26.4939 46.5005 26.2766C46.8764 26.0594 47.2914 25.9183 47.7218 25.8615C48.1522 25.8046 48.5895 25.8331 49.0089 25.9453C49.4283 26.0575 49.8215 26.2512 50.1661 26.5153L50.167 26.516L50.0963 26.6142L50.1689 26.516C50.864 27.0502 51.3188 27.8384 51.4334 28.7075C51.5481 29.5767 51.3132 30.4558 50.7804 31.152L37.3821 48.6239C37.0721 49.0264 36.6735 49.3522 36.2173 49.5759C35.7611 49.7995 35.2595 49.9151 34.7515 49.9136L34.7486 49.9175Z"
        fill="white"
      />
    </svg>
  );
}
